import type { SearchCalendarEvent } from 'constants/searchCalendarEvents'

/** Every downstream `useMemo` keys off this array, so it cannot be rebuilt per render. */
const NO_EVENTS: ReadonlyArray<SearchCalendarEvent> = []

/**
 * Calendar events for the hotel search date picker overlay.
 *
 * The recommendation API feed is disabled — returns an empty list until re-enabled.
 */
function useSearchCalendarEvents(_isEnabled: boolean): ReadonlyArray<SearchCalendarEvent> {
  return NO_EVENTS
}

export default useSearchCalendarEvents
